import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeComponent } from 'src/app/modules/home/home.component';
import { PortalComponent } from './portal.component';
import { SharedModule } from 'src/app/shared/shared.module';
@NgModule({
  declarations: [
    PortalComponent,
    HomeComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
  ],
})
export class PortalModule { }
